import React from 'react'

import { badge } from '@ui-kit/components/Badge/styles'

import type { Props } from './types'

const Badge = (props: Props) => {
  const { container, outerCircle, innerCircle } = badge({
    position: props.position,
    variant: props.variant,
  })
  return (
    <div className={container()} data-testid={props.testID}>
      <div className={outerCircle()}>
        <div className={innerCircle()} />
      </div>
    </div>
  )
}

export default Badge
